import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// components
import AboutAndHelp from './AboutAndHelp';
import MobileApps from './MobileApps';
import SocialAndTerms from './SocialAndTerms';
import HomeStoreLinks from './StoreLinks';

// styles
import './Footer.less';

const HomeStoreFooter = () => {
  return (
    <footer className={cx('zola-ui', 'common-footer', 'home-store', 'common-footer--logo-rebrand')}>
      <div className="common-footer__container">
        <div className="common-footer__desktop">
          <HomeStoreLinks />
        </div>
        <div className="common-footer__mobile">
          <HomeStoreLinks />
        </div>
      </div>
    </footer>
  );
};

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isIos: /iP(hone|od|ad)/i.test(navigator.userAgent),
      isAndroid: /Android/i.test(navigator.userAgent),
    };
  }

  render() {
    const { isIos, isAndroid } = this.state;
    const { isWebStore } = this.props;

    if (isWebStore) {
      return <HomeStoreFooter />;
    }

    return (
      <footer className={cx('zola-ui', 'common-footer', 'common-footer--logo-rebrand')}>
        <div className="common-footer__container">
          <div className="common-footer__desktop">
            <SocialAndTerms />
            <AboutAndHelp />
            <MobileApps isAndroid={isAndroid} isIos={isIos} />
          </div>
          <div className="common-footer__mobile">
            <MobileApps isAndroid={isAndroid} isIos={isIos} />
            <AboutAndHelp />
            <SocialAndTerms />
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  isWebStore: PropTypes.bool,
};

export default Footer;
